<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_brand_name') || '品牌名称'"
            prop="brandName"
          >
            <el-input
              clearable
              v-model="formData.brandName"
              :placeholder="$l('form_label_pe_brand_name') || '请输入品牌名称'"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_brand_status') || '有效状态'"
            prop="brandStatus"
          >
            <br />
            <el-radio-group v-model="formData.brandStatus" :disabled="true">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_has_E-commerce_brand') || '是否有电商品牌'"
            prop="isEcom"
          >
            <br />
            <el-radio-group v-model="formData.isEcom">
              <el-radio label="Y">{{ $l('INDEX.YES') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('INDEX.NO') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_Ecommerce_brand_number') || '电商品牌编号'"
            prop="ecomBrandNo"
          >
            <el-input
              clearable
              v-model="formData.ecomBrandNo"
              maxlength="2"
              show-word-limit
              @input="
                (e) => {
                  formData.ecomBrandNo = toUppercase(e)
                }
              "
              :disabled="formData.isEcom != 'Y'"
              :placeholder="
                $l('form_placeholder_Ecommerce_brand_number') ||
                  '请输入电商品牌编号'
              "
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_brand_desc') || '品牌介绍'"
            prop="brandDesc"
          >
            <el-input
              v-model="formData.brandDesc"
              type="textarea"
              :placeholder="$l('form_label_pe_brand_desc') || '请输入品牌介绍'"
              maxlength="1000"
              show-word-limit
              :rows="3"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_create_by') || '创建人'"
            prop="createByName"
          >
            <el-input
              clearable
              v-model="formData.createByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_create_date') || '创建时间'"
            prop="createDate"
          >
            <el-input
              clearable
              v-model="formData.createDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_modify_by') || '修改人'"
            prop="modifyByName"
          >
            <el-input
              clearable
              v-model="formData.modifyByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('form_label_modify_date') || '修改时间'"
            prop="modifyDate"
          >
            <el-input
              clearable
              v-model="formData.modifyDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          this.$l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          this.$l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'

export default {
  props: {
    disabled: Boolean,
    brandCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        brandStatus: 'Y',
        isEcom: 'N',
      },
    }
  },
  computed: {
    rules() {
      return {
        brandName: [
          {
            required: true,
            message: this.$l('form_label_pe_brand_desc') || '请输入品牌介绍',
            trigger: 'blur',
          },
        ],
        ecomBrandNo: [
          {
            required: this.formData.isEcom == 'Y',
            message:
              this.$l('form_label_pe_ecommerce_brand_number') ||
              '请输入电商品牌编号',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (
                this.rules.ecomBrandNo[0].required &&
                value &&
                value.length < 2
              ) {
                return callback(
                  new Error(
                    this.$l(
                      'form_label_ecommerce_brand_number_must_be_two' ||
                        '电商品牌编号须为两位'
                    )
                  )
                )
              }
              callback()
            },
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.brandCode) return

      this.$api
        .masterBrandDetailApi({
          brandCode: this.brandCode,
        })
        .then((res) => {
          console.log(res.body)
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterBrandSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    toUppercase(e) {
      return e.replace(/[^A-z]*/g, '').toLocaleUpperCase()
    },
  },
}
</script>
